module.exports = __webpack_public_path__ + "img/12angry-12.2a54289d.jpg";